import React from 'react';

import CheckmarkSVG from '../../assets/Checkmark.jsx';
import { useMediaQuery } from "react-responsive";


const StepIcon = ({ children, completed, width = 28, height = 28 }) => {

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  
  return (
    <div className={`${isMobile ? `w-[30px] h-[30px]` : `w-[28px] h-[28px]`} flex-shrink-0 rounded-full border-[1px] ${completed ? 'bg-shi-green border-shi-green' : 'border-shi-green'}`}>
      <div className={`w-full h-full text-black items-center justify-center flex flex-shrink-0`}>
        {completed ? <span className="text-white"><CheckmarkSVG width={28} height={28}/></span> : children}
      </div>
    </div>
  );
};

export default StepIcon;